var _title, _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMapPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "map-pin")), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.58,
    cy: 20.19,
    rx: 19.13,
    ry: 18.77,
    transform: "translate(-6.88 11.41) rotate(-26.72)",
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.05,2.59a.58.58,0,0,1,.21-.07,14,14,0,0,1-.41-1.44L23.34.85A.44.44,0,0,1,23.08.3v0A19.91,19.91,0,0,0,0,19.23a20.19,20.19,0,0,0,2.12,9.69,1.3,1.3,0,0,0,2.32-1.16A17.35,17.35,0,0,1,15.2,3.25,17.52,17.52,0,0,1,23,2.86H23a4.53,4.53,0,0,1,.74.07A.53.53,0,0,1,24.05,2.59Z",
    fill: "#3c74ba"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.12,32.72a18,18,0,0,1-4.39-6.57c-.61-1.55-2.91-.38-2.31,1.16a20.12,20.12,0,0,0,25,11.61,19.49,19.49,0,0,0,3-1.29l.12-.07.06,0a2.29,2.29,0,0,0,.88-1.6A3.84,3.84,0,0,0,30,34.2,17.53,17.53,0,0,1,8.12,32.72Z",
    fill: "#69be54"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23,2.88A17.36,17.36,0,0,1,34.7,29.31a17.6,17.6,0,0,1-6.85,6.19A1.3,1.3,0,0,0,29,37.81,20.2,20.2,0,0,0,39.73,23.18,20,20,0,0,0,33.55,5.3,20.56,20.56,0,0,0,23.2.29,1.31,1.31,0,0,0,21.83,1.5,1.32,1.32,0,0,0,23,2.88Z",
    fill: "#f7c812"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.94,22.33a12.27,12.27,0,0,1-8.75,9.43A12.32,12.32,0,0,1,10,26.8a1.3,1.3,0,0,0-1.83-.09c-.57.51-.66.83-.25,1.41s.78,1.15,1.18,1.66l.36.43a14.67,14.67,0,0,0,25-7.07,1.35,1.35,0,0,0-.83-1.64,1.3,1.3,0,0,0-1.63.83Z",
    fill: "#3c74ba"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.23,10.47A15.12,15.12,0,0,0,22,5.5c.34.36.15,1.1-.45.93A5.55,5.55,0,0,0,20,6.5a12.13,12.13,0,0,1-1.81-.06A.78.78,0,0,1,18,6.37a1.11,1.11,0,0,0,0,.19,1.29,1.29,0,0,0,1.21,1.37,12.35,12.35,0,0,1,10,4.09,12.2,12.2,0,0,1,2.48,11.53c-.48,1.6,2,2.41,2.46.81A14.9,14.9,0,0,0,31.23,10.47Z",
    fill: "#69be54"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.12,28.18a12.11,12.11,0,0,1,11.51-20A1.3,1.3,0,0,0,24,7,1.33,1.33,0,0,0,22.8,5.62,14.67,14.67,0,0,0,9.07,29.76a1,1,0,0,0,.13.16,1.26,1.26,0,0,0,.31.26,1.31,1.31,0,0,0,1.61-2Z",
    fill: "#f7c812"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.48,13.48a6.67,6.67,0,0,1,6.73,4.14,6.55,6.55,0,0,1-.46,5.74,8.11,8.11,0,0,1-1.06,1.8c-1.21,1.14.3,2.71,1.52,1.56a9.21,9.21,0,0,0,1.76-2,9.14,9.14,0,0,0-9-13.73,1.3,1.3,0,0,0-1,1.52A1.32,1.32,0,0,0,19.48,13.48Z",
    fill: "#3c74ba"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2,24.47a6.58,6.58,0,0,1,5-11c1.66,0,1.83-2.57.16-2.59a9.18,9.18,0,0,0-7.08,15.36,1.3,1.3,0,0,0,1.92-1.74Z",
    fill: "#69be54"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.64,23.59a6.66,6.66,0,0,1-10.91.31c-1-1.32-2.94.42-1.92,1.73a9.2,9.2,0,0,0,7.6,3.59A9.35,9.35,0,0,0,27.82,25a1.3,1.3,0,0,0-2.18-1.41Z",
    fill: "#f7c812"
  })));
}

export default SvgMapPin;